import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BaseUiModule } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-page-not-authorized',
  imports: [CommonModule, BaseUiModule, RouterLink],
  templateUrl: './not-authorized-page.component.html',
})
export class NotAuthorizedPageComponent {}
